import { render, staticRenderFns } from "./newsIndex.vue?vue&type=template&id=29593700&"
import script from "./newsIndex.vue?vue&type=script&lang=js&"
export * from "./newsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports